import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './TabList.scss';

function TabList(props) {
    const {
        children,
        className,
    } = props;

    return (
        <ul
            className={classNames(className, styles.tabList)}
            role="tablist"
        >
            {children}
        </ul>
    );
}

TabList.propTypes = {
    className: PropTypes.string,
};

export default TabList;
